import React, { Component } from 'react';
import './index.css';
import { Table } from 'antd';

import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../core/reducers';
import { actionGetDeviceList } from '../../../../core/actions/scanner/device';
import moment from 'moment'
import { RouterProps } from 'react-router-dom';

interface StateProps {
    deviceList: any
}

interface DispatchProps {
    getDeviceList(page)
}

type PropsType = RouterProps & StateProps
class Index extends Component<PropsType & DispatchProps> {
    

    state = {
        pageNum: 1,
        pageSize: 10
    }

    Columns;
    constructor (props) {
        super(props);
        this.Columns = [
            {
                title: '设备入库时间',
                dataIndex: 'inTime',
                key: 'inTime',
                render: (text) => {
                    if(!text) {
                        return;
                    }
                    else {
                        let time = moment(text).format('YYYY-MM-DD HH:mm:ss');
                        return <span>{time}</span>
                    }
                }
            },
            {
                title: '设备序列号',
                dataIndex: 'serialNumber',
                key: 'serialNumber'
            },
            {
                title: '设备状态',
                dataIndex: 'state',
                key: 'state',
                render: (text) => {
                    if(text === 'ONLINE') {
                        return <span>可用</span>
                    }
                    else {
                        return <span>不可用</span>
                    }
                }
            },
            {
                title: '设备出库时间',
                dataIndex: 'outTime',
                key: 'outTime',
                render: (text) => {
                    if(!text) {
                        return;
                    }
                    else {
                        let time = moment(text).format('YYYY-MM-DD HH:mm:ss');
                        return <span>{time}</span>
                    }
                }
            },
            {
                title: '操作',
                render: (record) => {
                    return (
                        <a onClick={() => this.goDetail(record)}>详情</a>
                    )
                }
            }
        ]
    }

    componentDidMount () {
        let page = {
            pageNum: this.state.pageNum,
            pageSize: this.state.pageSize
        }
        this.props.getDeviceList(page)
    }

    onPageChange = (pageNum, pageSize) => {
        let page = {
            pageNum: pageNum,
            pageSize: pageSize,
        }
        this.setState(page);
        this.props.getDeviceList(page)
    }

    onShowSizeChange = (current, pageSize) => {
        let page = {
            pageNum: current,
            pageSize: pageSize,
        }
        this.setState(page);
        this.props.getDeviceList(page)
    }

    goDetail = (record) => {
        const { history } = this.props;
        history.push('/institution/deviceList/detail/' + record.serialNumber)
    }

    render () {

        let data = this.props.deviceList || {};
        let list = data.deviceList || [];
        let total = +(data.totalElements || '0');
        let onTotal = data.deviceOnlineCount || 0;
        let offTotal = data.deviceOfflineCount || 0;

        return (
            <div className="device model">
                <h3>设备列表</h3>
                <ul className="device-head">
                    <li>
                        <p>设备总数</p>
                        <p>{total}</p>
                    </li>
                    <li>
                        <p>可用设备</p>
                        <p>{onTotal}</p>
                    </li>
                    <li>
                        <p>不可用设备</p>
                        <p>{offTotal}</p>
                    </li>
                </ul>
                <Table 
                    rowKey={(record) => record.serialNumber}
                    dataSource={list} 
                    columns={this.Columns}
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        current: this.state.pageNum,
                        defaultCurrent: this.state.pageNum,
                        onChange: this.onPageChange,
                        onShowSizeChange: this.onShowSizeChange,
                        showTotal: total => `总 ${total} 条`
                    }}
                    />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        deviceList: state.device.deviceList
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getDeviceList: (page) => {
            dispatch(actionGetDeviceList(page))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)